import { BASE_URL } from "@/constants/endpoints";
import { createAxiosWithAuth } from "@/utils/axios-config";
import { AxiosInstance } from "axios";

let pendingRequestsApiPromise: Promise<AxiosInstance> | null = null;

export interface PendingRequestsQuantity {
    efectivo: number
    cheque: number
}

const getPendingRequestsApi = () => {
  if (pendingRequestsApiPromise) return pendingRequestsApiPromise;
  pendingRequestsApiPromise = createAxiosWithAuth(BASE_URL, "jwt");
  return pendingRequestsApiPromise;
};

export const getPendingRequestsQuantity = async (): Promise<PendingRequestsQuantity | null> => {
  const api = await getPendingRequestsApi();
  if (!api) return null;
  const response = await api.get(
    `/Soporte/SolicitudesFinancierasPendientes`,
  );

  return response.data;
};
